import { isNoInfoUpdate } from '@pperform/pp-utils/parcelOrg';
import { DISPLAY_TYPE } from '@pperform/pp-constants/widgetConfigs';
import { SHIPMENT_STATUS } from '@pperform/pp-constants/parcel';
import { FeatureToggles } from 'interfaces/FeatureToggle.interface';
import { GlobalConfig } from '../interfaces/GlobalConfig.interface';

export const hasNoInfoUpdateParcel = (
  shipments,
  featureToggles: FeatureToggles,
): boolean => {
  if (shipments.length === 0) {
    return false;
  }

  const {
    returnManagement: { enablePreprintedReturnLabel },
  } = featureToggles;

  // CI: https://www.pivotaltracker.com/story/show/188620838
  if (!enablePreprintedReturnLabel) {
    if (shipments.length === 0) {
      return false;
    }

    const hasActiveParcels = shipments.some(
      (s) => s.shipmentStatus === SHIPMENT_STATUS.ACTIVE,
    );
    if (hasActiveParcels) {
      return false;
    }

    const hasReturnPending = shipments.some(
      (s) =>
        s.typeOfShipment === 'return' &&
        s.shipmentStatus === SHIPMENT_STATUS.PENDING,
    );
    if (hasReturnPending) {
      return false;
    }
  }

  return shipments.some(isNoInfoUpdate);
};

export const getNoInfoUpdateDisplayType = (
  shipments,
  globalConfig: GlobalConfig,
): string => {
  const isMultiParcel = shipments.length > 1;
  const hasFulfilledInfoParcel = shipments.some((s) => !isNoInfoUpdate(s));

  if (isMultiParcel && hasFulfilledInfoParcel) {
    return DISPLAY_TYPE.DETAILED_VIEW;
  }

  return globalConfig.config.noInfoUpdate.display;
};

export const isShownNoInfoUpdatePopup = (
  shipments,
  globalConfig: GlobalConfig,
  featureToggles: FeatureToggles,
): boolean => {
  return (
    hasNoInfoUpdateParcel(shipments, featureToggles) &&
    getNoInfoUpdateDisplayType(shipments, globalConfig) ===
      DISPLAY_TYPE.FULL_VIEW
  );
};

export const isShownNoInfoUpdateInline = (
  shipments,
  globalConfig: GlobalConfig,
  featureToggles: FeatureToggles,
): boolean => {
  return (
    hasNoInfoUpdateParcel(shipments, featureToggles) &&
    getNoInfoUpdateDisplayType(shipments, globalConfig) ===
      DISPLAY_TYPE.SEARCH_FORM_VIEW
  );
};
